"use strict";
/* @generated by `@turnkey/fetchers`. DO NOT EDIT BY HAND */
Object.defineProperty(exports, "__esModule", { value: true });
exports.signCreateWalletAccounts = exports.createWalletAccounts = exports.signCreateWallet = exports.createWallet = exports.signCreateUsers = exports.createUsers = exports.signCreateUserTag = exports.createUserTag = exports.signCreateSubOrganization = exports.createSubOrganization = exports.signCreatePrivateKeys = exports.createPrivateKeys = exports.signCreatePrivateKeyTag = exports.createPrivateKeyTag = exports.signCreatePolicy = exports.createPolicy = exports.signCreateInvitations = exports.createInvitations = exports.signCreateAuthenticators = exports.createAuthenticators = exports.signCreateApiOnlyUsers = exports.createApiOnlyUsers = exports.signCreateApiKeys = exports.createApiKeys = exports.signApproveActivity = exports.approveActivity = exports.signGetWhoami = exports.getWhoami = exports.signGetUsers = exports.getUsers = exports.signGetPrivateKeys = exports.getPrivateKeys = exports.signGetPolicies = exports.getPolicies = exports.signGetActivities = exports.getActivities = exports.signGetUser = exports.getUser = exports.signGetPrivateKey = exports.getPrivateKey = exports.signGetPolicy = exports.getPolicy = exports.signGetOrganization = exports.getOrganization = exports.signGetAuthenticators = exports.getAuthenticators = exports.signGetAuthenticator = exports.getAuthenticator = exports.signGetActivity = exports.getActivity = void 0;
exports.signNOOPCodegenAnchor = exports.nOOPCodegenAnchor = exports.signUpdateUserTag = exports.updateUserTag = exports.signUpdateUser = exports.updateUser = exports.signUpdateRootQuorum = exports.updateRootQuorum = exports.signUpdatePrivateKeyTag = exports.updatePrivateKeyTag = exports.signUpdatePolicy = exports.updatePolicy = exports.signUpdateAllowedOrigins = exports.updateAllowedOrigins = exports.signSignTransactionV2 = exports.signTransactionV2 = exports.signSignTransaction = exports.signTransaction = exports.signSignRawPayloadV2 = exports.signRawPayloadV2 = exports.signSignRawPayload = exports.signRawPayload = exports.signSetOrganizationFeature = exports.setOrganizationFeature = exports.signRemoveOrganizationFeature = exports.removeOrganizationFeature = exports.signRejectActivity = exports.rejectActivity = exports.signInitUserEmailRecovery = exports.initUserEmailRecovery = exports.signExportPrivateKey = exports.exportPrivateKey = exports.signDeletePolicy = exports.deletePolicy = exports.signDeleteInvitation = exports.deleteInvitation = exports.signDeleteAuthenticators = exports.deleteAuthenticators = exports.signDeleteApiKeys = exports.deleteApiKeys = void 0;
const base_1 = require("../../../../../base");
/**
 * Get Activity
 *
 * Get details about an Activity
 *
 * `POST /public/v1/query/get_activity`
 */
const getActivity = (input) => (0, base_1.request)({
    uri: "/public/v1/query/get_activity",
    method: "POST",
    body: input.body,
});
exports.getActivity = getActivity;
/**
 * Request a WebAuthn assertion and return a signed `GetActivity` request, ready to be POSTed to Turnkey.
 *
 * See {@link GetActivity}
 */
const signGetActivity = (input, options) => (0, base_1.signedRequest)({
    uri: "/public/v1/query/get_activity",
    body: input.body,
    options,
});
exports.signGetActivity = signGetActivity;
/**
 * Get Authenticator
 *
 * Get details about an authenticator
 *
 * `POST /public/v1/query/get_authenticator`
 */
const getAuthenticator = (input) => (0, base_1.request)({
    uri: "/public/v1/query/get_authenticator",
    method: "POST",
    body: input.body,
});
exports.getAuthenticator = getAuthenticator;
/**
 * Request a WebAuthn assertion and return a signed `GetAuthenticator` request, ready to be POSTed to Turnkey.
 *
 * See {@link GetAuthenticator}
 */
const signGetAuthenticator = (input, options) => (0, base_1.signedRequest)({
    uri: "/public/v1/query/get_authenticator",
    body: input.body,
    options,
});
exports.signGetAuthenticator = signGetAuthenticator;
/**
 * Get Authenticators
 *
 * Get details about authenticators for a user
 *
 * `POST /public/v1/query/get_authenticators`
 */
const getAuthenticators = (input) => (0, base_1.request)({
    uri: "/public/v1/query/get_authenticators",
    method: "POST",
    body: input.body,
});
exports.getAuthenticators = getAuthenticators;
/**
 * Request a WebAuthn assertion and return a signed `GetAuthenticators` request, ready to be POSTed to Turnkey.
 *
 * See {@link GetAuthenticators}
 */
const signGetAuthenticators = (input, options) => (0, base_1.signedRequest)({
    uri: "/public/v1/query/get_authenticators",
    body: input.body,
    options,
});
exports.signGetAuthenticators = signGetAuthenticators;
/**
 * Get Organization
 *
 * Get details about an Organization
 *
 * `POST /public/v1/query/get_organization`
 */
const getOrganization = (input) => (0, base_1.request)({
    uri: "/public/v1/query/get_organization",
    method: "POST",
    body: input.body,
});
exports.getOrganization = getOrganization;
/**
 * Request a WebAuthn assertion and return a signed `GetOrganization` request, ready to be POSTed to Turnkey.
 *
 * See {@link GetOrganization}
 */
const signGetOrganization = (input, options) => (0, base_1.signedRequest)({
    uri: "/public/v1/query/get_organization",
    body: input.body,
    options,
});
exports.signGetOrganization = signGetOrganization;
/**
 * Get Policy
 *
 * Get details about a Policy
 *
 * `POST /public/v1/query/get_policy`
 */
const getPolicy = (input) => (0, base_1.request)({
    uri: "/public/v1/query/get_policy",
    method: "POST",
    body: input.body,
});
exports.getPolicy = getPolicy;
/**
 * Request a WebAuthn assertion and return a signed `GetPolicy` request, ready to be POSTed to Turnkey.
 *
 * See {@link GetPolicy}
 */
const signGetPolicy = (input, options) => (0, base_1.signedRequest)({
    uri: "/public/v1/query/get_policy",
    body: input.body,
    options,
});
exports.signGetPolicy = signGetPolicy;
/**
 * Get Private Key
 *
 * Get details about a Private Key
 *
 * `POST /public/v1/query/get_private_key`
 */
const getPrivateKey = (input) => (0, base_1.request)({
    uri: "/public/v1/query/get_private_key",
    method: "POST",
    body: input.body,
});
exports.getPrivateKey = getPrivateKey;
/**
 * Request a WebAuthn assertion and return a signed `GetPrivateKey` request, ready to be POSTed to Turnkey.
 *
 * See {@link GetPrivateKey}
 */
const signGetPrivateKey = (input, options) => (0, base_1.signedRequest)({
    uri: "/public/v1/query/get_private_key",
    body: input.body,
    options,
});
exports.signGetPrivateKey = signGetPrivateKey;
/**
 * Get User
 *
 * Get details about a User
 *
 * `POST /public/v1/query/get_user`
 */
const getUser = (input) => (0, base_1.request)({
    uri: "/public/v1/query/get_user",
    method: "POST",
    body: input.body,
});
exports.getUser = getUser;
/**
 * Request a WebAuthn assertion and return a signed `GetUser` request, ready to be POSTed to Turnkey.
 *
 * See {@link GetUser}
 */
const signGetUser = (input, options) => (0, base_1.signedRequest)({
    uri: "/public/v1/query/get_user",
    body: input.body,
    options,
});
exports.signGetUser = signGetUser;
/**
 * List Activities
 *
 * List all Activities within an Organization
 *
 * `POST /public/v1/query/list_activities`
 */
const getActivities = (input) => (0, base_1.request)({
    uri: "/public/v1/query/list_activities",
    method: "POST",
    body: input.body,
});
exports.getActivities = getActivities;
/**
 * Request a WebAuthn assertion and return a signed `GetActivities` request, ready to be POSTed to Turnkey.
 *
 * See {@link GetActivities}
 */
const signGetActivities = (input, options) => (0, base_1.signedRequest)({
    uri: "/public/v1/query/list_activities",
    body: input.body,
    options,
});
exports.signGetActivities = signGetActivities;
/**
 * List Policies
 *
 * List all Policies within an Organization
 *
 * `POST /public/v1/query/list_policies`
 */
const getPolicies = (input) => (0, base_1.request)({
    uri: "/public/v1/query/list_policies",
    method: "POST",
    body: input.body,
});
exports.getPolicies = getPolicies;
/**
 * Request a WebAuthn assertion and return a signed `GetPolicies` request, ready to be POSTed to Turnkey.
 *
 * See {@link GetPolicies}
 */
const signGetPolicies = (input, options) => (0, base_1.signedRequest)({
    uri: "/public/v1/query/list_policies",
    body: input.body,
    options,
});
exports.signGetPolicies = signGetPolicies;
/**
 * List Private Keys
 *
 * List all Private Keys within an Organization
 *
 * `POST /public/v1/query/list_private_keys`
 */
const getPrivateKeys = (input) => (0, base_1.request)({
    uri: "/public/v1/query/list_private_keys",
    method: "POST",
    body: input.body,
});
exports.getPrivateKeys = getPrivateKeys;
/**
 * Request a WebAuthn assertion and return a signed `GetPrivateKeys` request, ready to be POSTed to Turnkey.
 *
 * See {@link GetPrivateKeys}
 */
const signGetPrivateKeys = (input, options) => (0, base_1.signedRequest)({
    uri: "/public/v1/query/list_private_keys",
    body: input.body,
    options,
});
exports.signGetPrivateKeys = signGetPrivateKeys;
/**
 * List Users
 *
 * List all Users within an Organization
 *
 * `POST /public/v1/query/list_users`
 */
const getUsers = (input) => (0, base_1.request)({
    uri: "/public/v1/query/list_users",
    method: "POST",
    body: input.body,
});
exports.getUsers = getUsers;
/**
 * Request a WebAuthn assertion and return a signed `GetUsers` request, ready to be POSTed to Turnkey.
 *
 * See {@link GetUsers}
 */
const signGetUsers = (input, options) => (0, base_1.signedRequest)({
    uri: "/public/v1/query/list_users",
    body: input.body,
    options,
});
exports.signGetUsers = signGetUsers;
/**
 * Who am I?
 *
 * Get basic information about your current API or WebAuthN user and their organization. Affords Sub-Organization look ups via Parent Organization for WebAuthN users.
 *
 * `POST /public/v1/query/whoami`
 */
const getWhoami = (input) => (0, base_1.request)({
    uri: "/public/v1/query/whoami",
    method: "POST",
    body: input.body,
});
exports.getWhoami = getWhoami;
/**
 * Request a WebAuthn assertion and return a signed `GetWhoami` request, ready to be POSTed to Turnkey.
 *
 * See {@link GetWhoami}
 */
const signGetWhoami = (input, options) => (0, base_1.signedRequest)({
    uri: "/public/v1/query/whoami",
    body: input.body,
    options,
});
exports.signGetWhoami = signGetWhoami;
/**
 * Approve Activity
 *
 * Approve an Activity
 *
 * `POST /public/v1/submit/approve_activity`
 */
const approveActivity = (input) => (0, base_1.request)({
    uri: "/public/v1/submit/approve_activity",
    method: "POST",
    body: input.body,
});
exports.approveActivity = approveActivity;
/**
 * Request a WebAuthn assertion and return a signed `ApproveActivity` request, ready to be POSTed to Turnkey.
 *
 * See {@link ApproveActivity}
 */
const signApproveActivity = (input, options) => (0, base_1.signedRequest)({
    uri: "/public/v1/submit/approve_activity",
    body: input.body,
    options,
});
exports.signApproveActivity = signApproveActivity;
/**
 * Create API Keys
 *
 * Add api keys to an existing User
 *
 * `POST /public/v1/submit/create_api_keys`
 */
const createApiKeys = (input) => (0, base_1.request)({
    uri: "/public/v1/submit/create_api_keys",
    method: "POST",
    body: input.body,
});
exports.createApiKeys = createApiKeys;
/**
 * Request a WebAuthn assertion and return a signed `CreateApiKeys` request, ready to be POSTed to Turnkey.
 *
 * See {@link CreateApiKeys}
 */
const signCreateApiKeys = (input, options) => (0, base_1.signedRequest)({
    uri: "/public/v1/submit/create_api_keys",
    body: input.body,
    options,
});
exports.signCreateApiKeys = signCreateApiKeys;
/**
 * Create API-only Users
 *
 * Create API-only Users in an existing Organization
 *
 * `POST /public/v1/submit/create_api_only_users`
 */
const createApiOnlyUsers = (input) => (0, base_1.request)({
    uri: "/public/v1/submit/create_api_only_users",
    method: "POST",
    body: input.body,
});
exports.createApiOnlyUsers = createApiOnlyUsers;
/**
 * Request a WebAuthn assertion and return a signed `CreateApiOnlyUsers` request, ready to be POSTed to Turnkey.
 *
 * See {@link CreateApiOnlyUsers}
 */
const signCreateApiOnlyUsers = (input, options) => (0, base_1.signedRequest)({
    uri: "/public/v1/submit/create_api_only_users",
    body: input.body,
    options,
});
exports.signCreateApiOnlyUsers = signCreateApiOnlyUsers;
/**
 * Create Authenticators
 *
 * Create Authenticators to authenticate requests to Turnkey
 *
 * `POST /public/v1/submit/create_authenticators`
 */
const createAuthenticators = (input) => (0, base_1.request)({
    uri: "/public/v1/submit/create_authenticators",
    method: "POST",
    body: input.body,
});
exports.createAuthenticators = createAuthenticators;
/**
 * Request a WebAuthn assertion and return a signed `CreateAuthenticators` request, ready to be POSTed to Turnkey.
 *
 * See {@link CreateAuthenticators}
 */
const signCreateAuthenticators = (input, options) => (0, base_1.signedRequest)({
    uri: "/public/v1/submit/create_authenticators",
    body: input.body,
    options,
});
exports.signCreateAuthenticators = signCreateAuthenticators;
/**
 * Create Invitations
 *
 * Create Invitations to join an existing Organization
 *
 * `POST /public/v1/submit/create_invitations`
 */
const createInvitations = (input) => (0, base_1.request)({
    uri: "/public/v1/submit/create_invitations",
    method: "POST",
    body: input.body,
});
exports.createInvitations = createInvitations;
/**
 * Request a WebAuthn assertion and return a signed `CreateInvitations` request, ready to be POSTed to Turnkey.
 *
 * See {@link CreateInvitations}
 */
const signCreateInvitations = (input, options) => (0, base_1.signedRequest)({
    uri: "/public/v1/submit/create_invitations",
    body: input.body,
    options,
});
exports.signCreateInvitations = signCreateInvitations;
/**
 * Create Policy
 *
 * Create a new Policy
 *
 * `POST /public/v1/submit/create_policy`
 */
const createPolicy = (input) => (0, base_1.request)({
    uri: "/public/v1/submit/create_policy",
    method: "POST",
    body: input.body,
});
exports.createPolicy = createPolicy;
/**
 * Request a WebAuthn assertion and return a signed `CreatePolicy` request, ready to be POSTed to Turnkey.
 *
 * See {@link CreatePolicy}
 */
const signCreatePolicy = (input, options) => (0, base_1.signedRequest)({
    uri: "/public/v1/submit/create_policy",
    body: input.body,
    options,
});
exports.signCreatePolicy = signCreatePolicy;
/**
 * Create Private Key Tag
 *
 * Create a private key tag and add it to private keys.
 *
 * `POST /public/v1/submit/create_private_key_tag`
 */
const createPrivateKeyTag = (input) => (0, base_1.request)({
    uri: "/public/v1/submit/create_private_key_tag",
    method: "POST",
    body: input.body,
});
exports.createPrivateKeyTag = createPrivateKeyTag;
/**
 * Request a WebAuthn assertion and return a signed `CreatePrivateKeyTag` request, ready to be POSTed to Turnkey.
 *
 * See {@link CreatePrivateKeyTag}
 */
const signCreatePrivateKeyTag = (input, options) => (0, base_1.signedRequest)({
    uri: "/public/v1/submit/create_private_key_tag",
    body: input.body,
    options,
});
exports.signCreatePrivateKeyTag = signCreatePrivateKeyTag;
/**
 * Create Private Keys
 *
 * Create new Private Keys
 *
 * `POST /public/v1/submit/create_private_keys`
 */
const createPrivateKeys = (input) => (0, base_1.request)({
    uri: "/public/v1/submit/create_private_keys",
    method: "POST",
    body: input.body,
});
exports.createPrivateKeys = createPrivateKeys;
/**
 * Request a WebAuthn assertion and return a signed `CreatePrivateKeys` request, ready to be POSTed to Turnkey.
 *
 * See {@link CreatePrivateKeys}
 */
const signCreatePrivateKeys = (input, options) => (0, base_1.signedRequest)({
    uri: "/public/v1/submit/create_private_keys",
    body: input.body,
    options,
});
exports.signCreatePrivateKeys = signCreatePrivateKeys;
/**
 * Create Sub-Organization
 *
 * Create a new Sub-Organization
 *
 * `POST /public/v1/submit/create_sub_organization`
 */
const createSubOrganization = (input) => (0, base_1.request)({
    uri: "/public/v1/submit/create_sub_organization",
    method: "POST",
    body: input.body,
});
exports.createSubOrganization = createSubOrganization;
/**
 * Request a WebAuthn assertion and return a signed `CreateSubOrganization` request, ready to be POSTed to Turnkey.
 *
 * See {@link CreateSubOrganization}
 */
const signCreateSubOrganization = (input, options) => (0, base_1.signedRequest)({
    uri: "/public/v1/submit/create_sub_organization",
    body: input.body,
    options,
});
exports.signCreateSubOrganization = signCreateSubOrganization;
/**
 * Create User Tag
 *
 * Create a user tag and add it to users.
 *
 * `POST /public/v1/submit/create_user_tag`
 */
const createUserTag = (input) => (0, base_1.request)({
    uri: "/public/v1/submit/create_user_tag",
    method: "POST",
    body: input.body,
});
exports.createUserTag = createUserTag;
/**
 * Request a WebAuthn assertion and return a signed `CreateUserTag` request, ready to be POSTed to Turnkey.
 *
 * See {@link CreateUserTag}
 */
const signCreateUserTag = (input, options) => (0, base_1.signedRequest)({
    uri: "/public/v1/submit/create_user_tag",
    body: input.body,
    options,
});
exports.signCreateUserTag = signCreateUserTag;
/**
 * Create Users
 *
 * Create Users in an existing Organization
 *
 * `POST /public/v1/submit/create_users`
 */
const createUsers = (input) => (0, base_1.request)({
    uri: "/public/v1/submit/create_users",
    method: "POST",
    body: input.body,
});
exports.createUsers = createUsers;
/**
 * Request a WebAuthn assertion and return a signed `CreateUsers` request, ready to be POSTed to Turnkey.
 *
 * See {@link CreateUsers}
 */
const signCreateUsers = (input, options) => (0, base_1.signedRequest)({
    uri: "/public/v1/submit/create_users",
    body: input.body,
    options,
});
exports.signCreateUsers = signCreateUsers;
/**
 * Create Wallet
 *
 * Create a Wallet
 *
 * `POST /public/v1/submit/create_wallet`
 */
const createWallet = (input) => (0, base_1.request)({
    uri: "/public/v1/submit/create_wallet",
    method: "POST",
    body: input.body,
});
exports.createWallet = createWallet;
/**
 * Request a WebAuthn assertion and return a signed `CreateWallet` request, ready to be POSTed to Turnkey.
 *
 * See {@link CreateWallet}
 */
const signCreateWallet = (input, options) => (0, base_1.signedRequest)({
    uri: "/public/v1/submit/create_wallet",
    body: input.body,
    options,
});
exports.signCreateWallet = signCreateWallet;
/**
 * Create Wallet accounts
 *
 * Create Wallet accounts
 *
 * `POST /public/v1/submit/create_wallet_accounts`
 */
const createWalletAccounts = (input) => (0, base_1.request)({
    uri: "/public/v1/submit/create_wallet_accounts",
    method: "POST",
    body: input.body,
});
exports.createWalletAccounts = createWalletAccounts;
/**
 * Request a WebAuthn assertion and return a signed `CreateWalletAccounts` request, ready to be POSTed to Turnkey.
 *
 * See {@link CreateWalletAccounts}
 */
const signCreateWalletAccounts = (input, options) => (0, base_1.signedRequest)({
    uri: "/public/v1/submit/create_wallet_accounts",
    body: input.body,
    options,
});
exports.signCreateWalletAccounts = signCreateWalletAccounts;
/**
 * Delete API Keys
 *
 * Remove api keys from a User
 *
 * `POST /public/v1/submit/delete_api_keys`
 */
const deleteApiKeys = (input) => (0, base_1.request)({
    uri: "/public/v1/submit/delete_api_keys",
    method: "POST",
    body: input.body,
});
exports.deleteApiKeys = deleteApiKeys;
/**
 * Request a WebAuthn assertion and return a signed `DeleteApiKeys` request, ready to be POSTed to Turnkey.
 *
 * See {@link DeleteApiKeys}
 */
const signDeleteApiKeys = (input, options) => (0, base_1.signedRequest)({
    uri: "/public/v1/submit/delete_api_keys",
    body: input.body,
    options,
});
exports.signDeleteApiKeys = signDeleteApiKeys;
/**
 * Delete Authenticators
 *
 * Remove authenticators from a User
 *
 * `POST /public/v1/submit/delete_authenticators`
 */
const deleteAuthenticators = (input) => (0, base_1.request)({
    uri: "/public/v1/submit/delete_authenticators",
    method: "POST",
    body: input.body,
});
exports.deleteAuthenticators = deleteAuthenticators;
/**
 * Request a WebAuthn assertion and return a signed `DeleteAuthenticators` request, ready to be POSTed to Turnkey.
 *
 * See {@link DeleteAuthenticators}
 */
const signDeleteAuthenticators = (input, options) => (0, base_1.signedRequest)({
    uri: "/public/v1/submit/delete_authenticators",
    body: input.body,
    options,
});
exports.signDeleteAuthenticators = signDeleteAuthenticators;
/**
 * Delete Invitation
 *
 * Delete an existing Invitation
 *
 * `POST /public/v1/submit/delete_invitations`
 */
const deleteInvitation = (input) => (0, base_1.request)({
    uri: "/public/v1/submit/delete_invitations",
    method: "POST",
    body: input.body,
});
exports.deleteInvitation = deleteInvitation;
/**
 * Request a WebAuthn assertion and return a signed `DeleteInvitation` request, ready to be POSTed to Turnkey.
 *
 * See {@link DeleteInvitation}
 */
const signDeleteInvitation = (input, options) => (0, base_1.signedRequest)({
    uri: "/public/v1/submit/delete_invitations",
    body: input.body,
    options,
});
exports.signDeleteInvitation = signDeleteInvitation;
/**
 * Delete Policy
 *
 * Delete an existing Policy
 *
 * `POST /public/v1/submit/delete_policy`
 */
const deletePolicy = (input) => (0, base_1.request)({
    uri: "/public/v1/submit/delete_policy",
    method: "POST",
    body: input.body,
});
exports.deletePolicy = deletePolicy;
/**
 * Request a WebAuthn assertion and return a signed `DeletePolicy` request, ready to be POSTed to Turnkey.
 *
 * See {@link DeletePolicy}
 */
const signDeletePolicy = (input, options) => (0, base_1.signedRequest)({
    uri: "/public/v1/submit/delete_policy",
    body: input.body,
    options,
});
exports.signDeletePolicy = signDeletePolicy;
/**
 * Export Private Key
 *
 * Exports a Private Key
 *
 * `POST /public/v1/submit/export_private_key`
 */
const exportPrivateKey = (input) => (0, base_1.request)({
    uri: "/public/v1/submit/export_private_key",
    method: "POST",
    body: input.body,
});
exports.exportPrivateKey = exportPrivateKey;
/**
 * Request a WebAuthn assertion and return a signed `ExportPrivateKey` request, ready to be POSTed to Turnkey.
 *
 * See {@link ExportPrivateKey}
 */
const signExportPrivateKey = (input, options) => (0, base_1.signedRequest)({
    uri: "/public/v1/submit/export_private_key",
    body: input.body,
    options,
});
exports.signExportPrivateKey = signExportPrivateKey;
/**
 * Init Recovery
 *
 * Initializes a new recovery
 *
 * `POST /public/v1/submit/init_user_email_recovery`
 */
const initUserEmailRecovery = (input) => (0, base_1.request)({
    uri: "/public/v1/submit/init_user_email_recovery",
    method: "POST",
    body: input.body,
});
exports.initUserEmailRecovery = initUserEmailRecovery;
/**
 * Request a WebAuthn assertion and return a signed `InitUserEmailRecovery` request, ready to be POSTed to Turnkey.
 *
 * See {@link InitUserEmailRecovery}
 */
const signInitUserEmailRecovery = (input, options) => (0, base_1.signedRequest)({
    uri: "/public/v1/submit/init_user_email_recovery",
    body: input.body,
    options,
});
exports.signInitUserEmailRecovery = signInitUserEmailRecovery;
/**
 * Reject Activity
 *
 * Reject an Activity
 *
 * `POST /public/v1/submit/reject_activity`
 */
const rejectActivity = (input) => (0, base_1.request)({
    uri: "/public/v1/submit/reject_activity",
    method: "POST",
    body: input.body,
});
exports.rejectActivity = rejectActivity;
/**
 * Request a WebAuthn assertion and return a signed `RejectActivity` request, ready to be POSTed to Turnkey.
 *
 * See {@link RejectActivity}
 */
const signRejectActivity = (input, options) => (0, base_1.signedRequest)({
    uri: "/public/v1/submit/reject_activity",
    body: input.body,
    options,
});
exports.signRejectActivity = signRejectActivity;
/**
 * Remove Organization Feature
 *
 * Removes an organization feature
 *
 * `POST /public/v1/submit/remove_organization_feature`
 */
const removeOrganizationFeature = (input) => (0, base_1.request)({
    uri: "/public/v1/submit/remove_organization_feature",
    method: "POST",
    body: input.body,
});
exports.removeOrganizationFeature = removeOrganizationFeature;
/**
 * Request a WebAuthn assertion and return a signed `RemoveOrganizationFeature` request, ready to be POSTed to Turnkey.
 *
 * See {@link RemoveOrganizationFeature}
 */
const signRemoveOrganizationFeature = (input, options) => (0, base_1.signedRequest)({
    uri: "/public/v1/submit/remove_organization_feature",
    body: input.body,
    options,
});
exports.signRemoveOrganizationFeature = signRemoveOrganizationFeature;
/**
 * Set Organization Feature
 *
 * Sets an organization feature
 *
 * `POST /public/v1/submit/set_organization_feature`
 */
const setOrganizationFeature = (input) => (0, base_1.request)({
    uri: "/public/v1/submit/set_organization_feature",
    method: "POST",
    body: input.body,
});
exports.setOrganizationFeature = setOrganizationFeature;
/**
 * Request a WebAuthn assertion and return a signed `SetOrganizationFeature` request, ready to be POSTed to Turnkey.
 *
 * See {@link SetOrganizationFeature}
 */
const signSetOrganizationFeature = (input, options) => (0, base_1.signedRequest)({
    uri: "/public/v1/submit/set_organization_feature",
    body: input.body,
    options,
});
exports.signSetOrganizationFeature = signSetOrganizationFeature;
/**
 * Sign Raw Payload
 *
 * Sign a raw payload with a Private Key
 *
 * `POST /public/v1/submit/sign_raw_payload`
 */
const signRawPayload = (input) => (0, base_1.request)({
    uri: "/public/v1/submit/sign_raw_payload",
    method: "POST",
    body: input.body,
});
exports.signRawPayload = signRawPayload;
/**
 * Request a WebAuthn assertion and return a signed `SignRawPayload` request, ready to be POSTed to Turnkey.
 *
 * See {@link SignRawPayload}
 */
const signSignRawPayload = (input, options) => (0, base_1.signedRequest)({
    uri: "/public/v1/submit/sign_raw_payload",
    body: input.body,
    options,
});
exports.signSignRawPayload = signSignRawPayload;
/**
 * Sign Raw Payload
 *
 * Sign a raw payload with a Private Key id or address
 *
 * `POST /public/v1/submit/sign_raw_payload_v2`
 */
const signRawPayloadV2 = (input) => (0, base_1.request)({
    uri: "/public/v1/submit/sign_raw_payload_v2",
    method: "POST",
    body: input.body,
});
exports.signRawPayloadV2 = signRawPayloadV2;
/**
 * Request a WebAuthn assertion and return a signed `SignRawPayloadV2` request, ready to be POSTed to Turnkey.
 *
 * See {@link SignRawPayloadV2}
 */
const signSignRawPayloadV2 = (input, options) => (0, base_1.signedRequest)({
    uri: "/public/v1/submit/sign_raw_payload_v2",
    body: input.body,
    options,
});
exports.signSignRawPayloadV2 = signSignRawPayloadV2;
/**
 * Sign Transaction
 *
 * Sign a transaction with a Private Key
 *
 * `POST /public/v1/submit/sign_transaction`
 */
const signTransaction = (input) => (0, base_1.request)({
    uri: "/public/v1/submit/sign_transaction",
    method: "POST",
    body: input.body,
});
exports.signTransaction = signTransaction;
/**
 * Request a WebAuthn assertion and return a signed `SignTransaction` request, ready to be POSTed to Turnkey.
 *
 * See {@link SignTransaction}
 */
const signSignTransaction = (input, options) => (0, base_1.signedRequest)({
    uri: "/public/v1/submit/sign_transaction",
    body: input.body,
    options,
});
exports.signSignTransaction = signSignTransaction;
/**
 * Sign Transaction
 *
 * Sign a transaction with a Private Key id or address
 *
 * `POST /public/v1/submit/sign_transaction_v2`
 */
const signTransactionV2 = (input) => (0, base_1.request)({
    uri: "/public/v1/submit/sign_transaction_v2",
    method: "POST",
    body: input.body,
});
exports.signTransactionV2 = signTransactionV2;
/**
 * Request a WebAuthn assertion and return a signed `SignTransactionV2` request, ready to be POSTed to Turnkey.
 *
 * See {@link SignTransactionV2}
 */
const signSignTransactionV2 = (input, options) => (0, base_1.signedRequest)({
    uri: "/public/v1/submit/sign_transaction_v2",
    body: input.body,
    options,
});
exports.signSignTransactionV2 = signSignTransactionV2;
/**
 * Update Allowable Origins
 *
 * Update the allowable origins for credentials and requests
 *
 * `POST /public/v1/submit/update_allowed_origins`
 */
const updateAllowedOrigins = (input) => (0, base_1.request)({
    uri: "/public/v1/submit/update_allowed_origins",
    method: "POST",
    body: input.body,
});
exports.updateAllowedOrigins = updateAllowedOrigins;
/**
 * Request a WebAuthn assertion and return a signed `UpdateAllowedOrigins` request, ready to be POSTed to Turnkey.
 *
 * See {@link UpdateAllowedOrigins}
 */
const signUpdateAllowedOrigins = (input, options) => (0, base_1.signedRequest)({
    uri: "/public/v1/submit/update_allowed_origins",
    body: input.body,
    options,
});
exports.signUpdateAllowedOrigins = signUpdateAllowedOrigins;
/**
 * Update Policy
 *
 * Update an existing Policy
 *
 * `POST /public/v1/submit/update_policy`
 */
const updatePolicy = (input) => (0, base_1.request)({
    uri: "/public/v1/submit/update_policy",
    method: "POST",
    body: input.body,
});
exports.updatePolicy = updatePolicy;
/**
 * Request a WebAuthn assertion and return a signed `UpdatePolicy` request, ready to be POSTed to Turnkey.
 *
 * See {@link UpdatePolicy}
 */
const signUpdatePolicy = (input, options) => (0, base_1.signedRequest)({
    uri: "/public/v1/submit/update_policy",
    body: input.body,
    options,
});
exports.signUpdatePolicy = signUpdatePolicy;
/**
 * Update Private Key Tag
 *
 * Update human-readable name or associated private keys. Note that this activity is atomic: all of the updates will succeed at once, or all of them will fail.
 *
 * `POST /public/v1/submit/update_private_key_tag`
 */
const updatePrivateKeyTag = (input) => (0, base_1.request)({
    uri: "/public/v1/submit/update_private_key_tag",
    method: "POST",
    body: input.body,
});
exports.updatePrivateKeyTag = updatePrivateKeyTag;
/**
 * Request a WebAuthn assertion and return a signed `UpdatePrivateKeyTag` request, ready to be POSTed to Turnkey.
 *
 * See {@link UpdatePrivateKeyTag}
 */
const signUpdatePrivateKeyTag = (input, options) => (0, base_1.signedRequest)({
    uri: "/public/v1/submit/update_private_key_tag",
    body: input.body,
    options,
});
exports.signUpdatePrivateKeyTag = signUpdatePrivateKeyTag;
/**
 * Update Root Quorum
 *
 * Set the threshold and members of the root quorum. This must be approved by the current root quorum.
 *
 * `POST /public/v1/submit/update_root_quorum`
 */
const updateRootQuorum = (input) => (0, base_1.request)({
    uri: "/public/v1/submit/update_root_quorum",
    method: "POST",
    body: input.body,
});
exports.updateRootQuorum = updateRootQuorum;
/**
 * Request a WebAuthn assertion and return a signed `UpdateRootQuorum` request, ready to be POSTed to Turnkey.
 *
 * See {@link UpdateRootQuorum}
 */
const signUpdateRootQuorum = (input, options) => (0, base_1.signedRequest)({
    uri: "/public/v1/submit/update_root_quorum",
    body: input.body,
    options,
});
exports.signUpdateRootQuorum = signUpdateRootQuorum;
/**
 * Update User
 *
 * Update a User in an existing Organization
 *
 * `POST /public/v1/submit/update_user`
 */
const updateUser = (input) => (0, base_1.request)({
    uri: "/public/v1/submit/update_user",
    method: "POST",
    body: input.body,
});
exports.updateUser = updateUser;
/**
 * Request a WebAuthn assertion and return a signed `UpdateUser` request, ready to be POSTed to Turnkey.
 *
 * See {@link UpdateUser}
 */
const signUpdateUser = (input, options) => (0, base_1.signedRequest)({
    uri: "/public/v1/submit/update_user",
    body: input.body,
    options,
});
exports.signUpdateUser = signUpdateUser;
/**
 * Update User Tag
 *
 * Update human-readable name or associated users. Note that this activity is atomic: all of the updates will succeed at once, or all of them will fail.
 *
 * `POST /public/v1/submit/update_user_tag`
 */
const updateUserTag = (input) => (0, base_1.request)({
    uri: "/public/v1/submit/update_user_tag",
    method: "POST",
    body: input.body,
});
exports.updateUserTag = updateUserTag;
/**
 * Request a WebAuthn assertion and return a signed `UpdateUserTag` request, ready to be POSTed to Turnkey.
 *
 * See {@link UpdateUserTag}
 */
const signUpdateUserTag = (input, options) => (0, base_1.signedRequest)({
    uri: "/public/v1/submit/update_user_tag",
    body: input.body,
    options,
});
exports.signUpdateUserTag = signUpdateUserTag;
/**
 * `POST /tkhq/api/v1/noop-codegen-anchor`
 */
const nOOPCodegenAnchor = () => (0, base_1.request)({
    uri: "/tkhq/api/v1/noop-codegen-anchor",
    method: "POST",
});
exports.nOOPCodegenAnchor = nOOPCodegenAnchor;
/**
 * Request a WebAuthn assertion and return a signed `NOOPCodegenAnchor` request, ready to be POSTed to Turnkey.
 *
 * See {@link NOOPCodegenAnchor}
 */
const signNOOPCodegenAnchor = () => (0, base_1.signedRequest)({
    uri: "/tkhq/api/v1/noop-codegen-anchor",
});
exports.signNOOPCodegenAnchor = signNOOPCodegenAnchor;
//# sourceMappingURL=public_api.fetcher.js.map